import { render, staticRenderFns } from "./InsentifLayout.vue?vue&type=template&id=90ed1ea8&scoped=true"
import script from "./InsentifLayout.vue?vue&type=script&lang=js"
export * from "./InsentifLayout.vue?vue&type=script&lang=js"
import style0 from "./InsentifLayout.vue?vue&type=style&index=0&id=90ed1ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ed1ea8",
  null
  
)

export default component.exports